import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import _, { isEmpty } from 'lodash';

import { defaultModal, openModal, showModal } from '../../helpers/modals';
import Order from './Modals/Order';
import Overview from '../dashboard/Overview/Overview';
import InventoryCard from './InventoryCard/InventoryCard';
import InventoryHeaders from './InventoryHeaders/InventoryHeaders';
import Loading from 'components/Loading/Loading';
import { pushNotificationWithTimeout } from 'modules/notifications/notificationsSlice';

import colors from '../../theme/Colors.module.scss';
import './Inventory.scss';

import {
  useGetInventoryOrdersQuery,
  useGetInventoryBalancesQuery,
} from 'modules/inventory/inventoryApi';

const Inventory = props => {
  const dispatch = useDispatch();

  const [inventoryModal, setInventoryModal] = useState(defaultModal);

  const {
    data: inventoryOrdersData,
    error: inventoryOrdersError,
    isLoading: inventoryOrdersIsLoading,
  } = useGetInventoryOrdersQuery();

  const {
    data: inventoryBalancesData,
    error: inventoryBalancesError,
    isLoading: inventoryBalancesIsLoading,
  } = useGetInventoryBalancesQuery();

  // const handlePageChange = (newPage, newSize) => {
  //   const newData = {
  //     current_page: newPage,
  //     size: newSize,
  //   };

  //   getInventoryOrders(newData);
  // };

  if (inventoryOrdersIsLoading || inventoryBalancesIsLoading) {
    return <Loading type="fullpage" />;
  }

  if (inventoryOrdersError) {
    dispatch(
      pushNotificationWithTimeout({
        type: 'error',
        message: 'Failed to fetch inventory orders',
      })
    );
  }

  if (inventoryBalancesError) {
    dispatch(
      pushNotificationWithTimeout({
        type: 'error',
        message: 'Failed to fetch inventory balances',
      })
    );
  }

  const buildInventoryBalances = () => {
    if (!isEmpty(inventoryBalancesData)) {
      const {
        cyan_balance,
        magenta_balance,
        yellow_balance,
        black_balance,
        paper_balance,
        // maintenance_balance,
      } = inventoryBalancesData;

      return (
        <ul className="overview">
          <Overview
            title={`Ink`}
            cards={[
              {
                icon: <i className="fas fa-tint" />,
                value: cyan_balance.toLocaleString(),
                title: 'Cyan',
                subTitle: null,
                bgColor: colors.cyan,
              },
              {
                icon: <i className="fas fa-tint" />,
                value: magenta_balance.toLocaleString(),
                title: `Magenta`,
                subTitle: null,
                bgColor: colors.magenta,
              },
              {
                icon: <i className="fas fa-tint" />,
                value: yellow_balance.toLocaleString(),
                title: 'Yellow',
                subTitle: null,
                bgColor: colors.pastelYellow,
              },
              {
                icon: <i className="fas fa-tint" />,
                value: black_balance.toLocaleString(),
                title: 'Black',
                subTitle: null,
                bgColor: colors.darkGrey,
              },
            ]}
          />

          <Overview
            title={`Paper`}
            cards={[
              {
                icon: <i className="fas fa-print" />,
                value: paper_balance.toLocaleString(),
                title: 'Paper',
                subTitle: null,
                bgColor: colors.grey,
              },
            ]}
          />

          <Overview
            title={`Maintenance`}
            cards={[
              {
                icon: <i className="fas fa-fill-drip" />,
                value: paper_balance.toLocaleString(),
                title: 'Maintenance',
                subTitle: null,
                bgColor: colors.slate,
              },
            ]}
          />
        </ul>
      );
    }
  };

  const buildInventoryOrders = () => {
    const renderContent = [];
    if (!isEmpty(inventoryOrdersData)) {
      inventoryOrdersData.forEach(order => {
        const title = `Order #${order.id} Summary`;

        renderContent.push(
          <InventoryCard
            key={_.uniqueId('inventoryCard_')}
            order={order}
            callback={() =>
              openModal(
                setInventoryModal,
                order.id,
                title,
                <Order order={order} />
              )
            }
          />
        );
      });
    }

    return (
      <div className="inventoryContainer">
        {renderContent}

        {isEmpty(inventoryOrdersData) && (
          <div className="noInventory">
            <p>No orders found...</p>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="inventoryOverview">{buildInventoryBalances()}</div>

      <div className="inventoryBody">
        <InventoryHeaders />
        {buildInventoryOrders()}
      </div>

      {showModal(inventoryModal, setInventoryModal)}
    </>
  );
};

export default Inventory;
